export enum Breakpoint {
  XS = 100,
  SM = 200,
  MD = 300,
  LG = 400,
  XL = 500,
  XXL = 600, 
};
